import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { CollectionContentShape } from '../../types';

export const BotCollectionContent = ({
    collectionContent,
}: {
    collectionContent: CollectionContentShape[];
}) => (
    <div className="collections-carousel__bot-container">
        {collectionContent.map(({ id, name }) => (
            <div
                className="collections-carousel__collection-link"
                key={id}
                data-testid="collection-carousel-bot-link"
            >
                <a href={`/c/${id}`} target="_blank" rel="noreferrer">
                    {gettext('%(name)s Collection', {
                        name,
                    })}
                </a>
            </div>
        ))}
    </div>
);
